<template>
  <app-select               
              :data-title="title"
              :data-menu-heading="title"
              data-menu-width="290px"
              :data-button-gradient="true"              
              @search="v => search(v)">
              
    <treeselect :value="establishmentsIds"
                class="local-filter"
                :normalizer="normalizer"
                :options="list"
                flat
                multiple
                clearable
                always-open
                sort-value-by="INDEX"
                value-consists-of="ALL"
                :noOptionsText="$t('message.generics.message.noOptionsText')"                
                @input="emitInput"></treeselect>
              
  </app-select>
</template>

<script>
    import AppSelect from '@components/Select'
    import filter from '@mixins/filter'
    import Treeselect from "@riophae/vue-treeselect";
    import loadsOnFilterUpdate from '@mixins/loads-on-filter-update'
    import _ from 'lodash'
    import {i18n} from "@packages/I18n";

    export default {


        components: {
            AppSelect,
            Treeselect
        },

        data() {
            return {
                key: 'establishments',
                establishmentsList:[],
                filteredEstablishmentsList: [],
                pagination: {
                    page: 0,
                    amountPerPage: 50,
                },
                page: 0,
                size: "",
                filter: "",
                order: "",
                normalizer(node) {
                    return {
                        id: node.id,
                        label: node.nameMaster,
                        children: node.children.length ? node.children : undefined,
                    };
                },
                searchText: undefined           
            }
        },

        props: {
            establishmentsIds: {
                type: Array
            }
        },        

        computed: {
            filters() {
                return this.$store.state.establishments.filters
            },

            title() {
                return  i18n.t('message.sidebar.message.establishments')
            },

            hasFilteredList() {
                return this.filteredEstablishmentsList.length > 0
            },

            list() {
                let list
                if(!this.searchText) {
                    list = this.establishmentsList
                } else if(this.searchText && this.hasFilteredList) {
                    list = this.filteredEstablishmentsList
                } else if(this.searchText && !this.hasFilteredList) {
                    list = []
                }
                list.map(establishment => establishment.children = [])
                return list
            }

        },

        methods: {
            async loadMore($state) {
                let list = await this.$loader.establishments.load({
                    pagination: this.pagination,
                    filters: this.filters
                })

                const apependList = _.map(list,
                    (establishment) => {
                        return {
                            id: establishment.id,
                            label: establishment.nome
                        }
                    }
                )

                this.list.push(...apependList)

                this.pagination.page += 1

                if(list.length) {
                    if($state) {
                        $state.loaded();
                    }
                } else {
                    if($state) {
                        $state.complete();
                    }
                }

            },
            async load() {
                const {content} = await this.$api.establishments.list({
                    page: this.page,
                    size: this.size,
                    filter: this.filter,
                    order: this.order,
                })
                this.establishmentsList = content                
            },

            search(search) {
                this.searchText = search;
                this.filteredEstablishmentsList = this.establishmentsList.filter(establishment => {
                    return establishment.nameMaster.toLowerCase().includes(search.toLowerCase())
                })                
            },            

            emitInput(val) {
                this.$emit('input', val)
            }
        },

        mounted() {
            this.$store.commit('ESTABLISHMENTS_SET_FILTER', {
                key: 'search',
                value: ''
            })
            // this.load()
        },

        mixins: [filter, loadsOnFilterUpdate]
    }
</script>

<style>
h3 {
  font-size: 100%;
}
</style>import { toLower } from 'lodash';
import { toLower } from 'lodash';

